import { pageBgColor } from "@/utils/theme";
import { Box, Grid2, Paper, Skeleton, Typography } from "@mui/material";

export const ShiftReportSkeleton = () => {
	return (
		<Grid2
			container
			spacing={1}
			style={{ padding: "10px 20px", backgroundColor: pageBgColor }}
		>
			<Grid2
				container
				size={12}
				justifyContent="space-between"
				alignItems="center"
			>
				<Grid2 size={{ md: 4 }} alignItems="center">
					<Typography
						variant="h5"
						sx={{
							fontWeight: 600,
							userSelect: "none",
						}}
					>
						Shift Report
					</Typography>
				</Grid2>
				<Grid2
					size={{ md: 4 }}
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						p: 1,
						mb: 1,
					}}
					component={Paper}
					elevation={1}
				>
					<Skeleton variant="rounded" width={400} height={40} />
				</Grid2>
				<Grid2
					size={{ md: 4 }}
					container
					justifyContent="flex-end"
					alignItems="center"
				>
					<Skeleton variant="rounded" width={150} height={36} />
				</Grid2>
			</Grid2>

			<Grid2 container size={12} spacing={1} sx={{ alignItems: "stretch" }}>
				<Grid2 size={{ xs: 3.25 }} component={Paper}>
					<Box padding={2}>
						<Typography
							variant="subtitle1"
							style={{ fontWeight: "600" }}
							marginBottom={0.5}
						>
							Shift Summary
						</Typography>
						<Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
							<Skeleton variant="rounded" width="50%" height={180} />
							<Skeleton variant="rounded" width="50%" height={180} />
						</Box>
					</Box>
				</Grid2>

				<Grid2 size={{ xs: 7 }}>
					<Grid2 container spacing={1}>
						{[1, 2, 3, 4].map((i) => (
							<Grid2 key={i} size={{ xs: 3 }}>
								<Skeleton variant="rounded" height={220} />
							</Grid2>
						))}
					</Grid2>
				</Grid2>

				<Grid2 size={{ xs: 1.75 }}>
					<Skeleton variant="rounded" height={220} />
				</Grid2>
			</Grid2>

			<Grid2 size={{ xs: 12 }} component={Paper}>
				<Box padding={2} style={{ position: "relative" }}>
					<Typography variant="h6" style={{ fontWeight: "600" }}>
						Gantt
					</Typography>
					<Skeleton variant="rounded" height={300} />
				</Box>
			</Grid2>

			<Grid2 size={{ xs: 12 }} component={Paper}>
				<Box padding={2}>
					<Typography
						variant="h6"
						style={{ fontWeight: "600" }}
						marginBottom={2}
					>
						Heats
					</Typography>
					<Grid2 height="30vh">
						{[1, 2, 3, 4, 5].map((i) => (
							<Skeleton key={i} variant="text" width="100%" height="6vh" />
						))}
					</Grid2>
				</Box>
			</Grid2>

			<Grid2 size={{ xs: 12 }} component={Paper}>
				<Box padding={2}>
					<Typography
						variant="h6"
						style={{ fontWeight: "600" }}
						marginBottom={2}
					>
						Production Summary
					</Typography>
					<Grid2 height="20vh">
						{[1, 2, 3].map((i) => (
							<Skeleton key={i} variant="text" width="100%" height="6vh" />
						))}
					</Grid2>
				</Box>
			</Grid2>

			<Grid2 size={{ xs: 12 }} component={Paper}>
				<Box padding={2}>
					<Typography
						variant="h6"
						style={{ fontWeight: "600" }}
						marginBottom={2}
					>
						Delays
					</Typography>
					<Grid2 height="35vh">
						{[1, 2, 3, 4, 5].map((i) => (
							<Skeleton key={i} variant="text" width="100%" height="7vh" />
						))}
					</Grid2>
				</Box>
			</Grid2>

			<Grid2 size={{ xs: 12 }} component={Paper}>
				<Box padding={2}>
					<Typography
						variant="h6"
						style={{ fontWeight: "600" }}
						marginBottom={2}
					>
						Logbook
					</Typography>
					<Grid2 height="35vh">
						{[1, 2, 3, 4, 5, 6, 7].map((i) => (
							<Skeleton key={i} variant="text" width="100%" height="5vh" />
						))}
					</Grid2>
				</Box>
			</Grid2>
		</Grid2>
	);
};
